export const Colors = {
  background: {
    DEFAULT: '#ffffff',
    gradient: '#F7F9FE',
    variant: '#F7F9FE',
    grey: '#F7F9FE',
    dark: '#F7F9FE',
  },
  foreground: '#000000',
  section: '#F7F9FE',
  footer: '#0540FA',
  badge: '#FFBD48',
  primary: {
    DEFAULT: '#0540FA',
    hover: '#0540FA',
    text: '#0540FA',
    foreground: '#ffffff',
  },
  secondary: {
    DEFAULT: '#FFBD48',
    hover: '#FFBD48',
    text: '#FFBD48',
    foreground: '#ffffff',
    variant: '#FFBD48',
  },
  tertiary: {
    DEFAULT: '#23C55F',
    hover: '#16E0AD',
    text: '#ffffff',
    foreground: '#ffffff',
    variant: '#49DE80',
  },
  success: '#22c55e',
  error: '#ef4444',
  accent: {
    DEFAULT: '#0540FA',
    foreground: '#000000',
  },
};
